import { render } from "./home-service.vue?vue&type=template&id=3b8b602a"
import script from "./home-service.vue?vue&type=script&lang=js"
export * from "./home-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__